;(function () {
  // Since this JS file is included in the global bundle and loaded on all pages -
  // we still only want to execute if there is a careers-quiz module on the page
  // otherwise return early.
  // Can potentially looks into only loading this JS file on the quiz template (like we are
  // for the VueJS library)
  if ($('.careers-quiz').length == 0) return

  // This is here because the client added a CTA in the header to scroll to the quiz module
  $('[href="#quiz"]').on('click', (e) => {
    e.preventDefault()
  })

  // These attributes were defined as part of planning out what questions/answers
  // the quiz should contain.
  // These are used for IDs in several places rather than using direct strings.
  // The ones commented out are currently not supported by the app - the client
  // wanted to focus on a reduced number of industries for first iteration.
  // The same goes for the questions and careers (see data object) which also have parts commented out.
  const Attributes = Object.freeze({
    WORK_WITH_PEOPLE: 'work_with_people',
    WORK_WITH_ANIMALS: 'work_with_animals',
    HELP_PEOPLE: 'help_people',
    TOOLS_MACHINERY: 'tools_machinery',
    TEACHING: 'teaching',
    WORK_WITH_HANDS: 'working_with_hands',
    WORK_INSIDE: 'work_inside',
    WORK_OUTSIDE: 'work_outside',
    ONE_ON_ONE: 'one_on_one_care',
    EMPLOYEE: 'employee',
    HEALTHCARE: 'healthcare',
    SHIFT_WORK: 'shift_work',
    TAFE_2YR: 'tafe_2yr',
    TAFE_1YR: 'tafe_1yr',
    TAFE_6MO: 'tafe_6mo',
    // TAFE_18MO: "tafe_18mo",
    COMMUNITY: 'community',
    COMMUNITY_PROBS: 'community_probs',
    OFFICE: 'office',
    NINE_TO_FIVE: 'nine_to_five',
    SUPPORT_ADDICTS: 'support_addicts',
    KIDS: 'kids',
    SCHOOL: 'school',
    ADULTS: 'adults',
    OWN_BUSINESS: 'own_business',
    NUMBERS: 'numbers',
    LOCAL_TRAVEL: 'local_travel',
    MANUAL_LABOUR: 'manual_labour',
    APPRENTICE: 'apprentice',
    GADGETS: 'gadgets',
    COMPUTERS: "computers",
    CREATIVE: "creative",
    KITCHEN: "kitchen",
    // SALON: "salon",
    FARM: "farm",
    // FACTORY: "factory",
    PLANTS: "plants",
    OWN_HOURS: 'own_hours',
    // PROCESS: "process"
  })

  const ScreenTypes = Object.freeze({
    START: 'start',
    QUESTION: 'question',
    RESULTS: 'results',
  })

  function focusOnElement(selector, speed, callback) {
    const el = $(selector)
    if (el.length > 0) $('html, body').animate({ scrollTop: el.offset().top - 80 }, speed, callback)
  }

  const templateHTML = /* html */ `
  <div class="py-5">
    <button v-if="!hasStarted" class="btn btn-large btn-secondary-reversed" @click="onStartClick">Start Quiz</button>
    <transition name="vue-fade">
      <div v-if="hasStarted">
        <div v-for="(question, i) in displayedQuestions" :key="question.id" class="careers-quiz__screen" :class="{answered: questionIsAnswered(question), current: i == answeredQuestionCount}">
        <div class="mb-3 d-flex align-items-start"><h4 class="mr-4">{{question.text}}</h4><span class="careers-quiz__progress  ml-auto">Question {{i+1}} / {{questions.length}}</span></div>
          <div class="careers-quiz__options">
            <div v-for="opt in question.options" :q-id="question.id" class="careers-quiz__option p-3 d-flex align-items-center" @click="selectOption(question, opt)" :class="{selected: optionIsSelected(question, opt)}">
              <svg-icon :icon-name="opt.icon"/><span class="ml-3">{{opt.text}}</span>
            </div>
          </div>
        </div>  
      </div>
    </transition>
    <transition name="vue-fade">
      <div v-if="quizIsComplete && results.length > 0" class="careers-quiz__results mt-5 text-center">
        <h2>Results</h2>
        <p>Based on your responses, here are the careers that best suit your interests.</p>
        <div v-for="(job, i) in results" :key="i" class="careers-quiz__results-job p-4 mt-4 d-md-flex align-items-center text-left">
          <div>
            <h3>{{job.name}}</h3>
            <p class="mb-0">{{job.description}}</p>
          </div>
          <a :href="'/plan-your-future/' + job.slug" class="careers-quiz__result-cta btn btn-large btn-primary mt-4 mt-md-0 ml-md-4">Learn more about this career</a>
        </div>
        <p class="careers-quiz__again-text mt-4">Didn't find the career you were looking for? Think about what you enjoy doing and the kind of lifestyle you can see yourself living, and try taking the quiz again with different responses.</p>
        <button class="btn btn-large btn-secondary-reversed mt-3" @click="restartQuiz">Take quiz again</button>
      </div>
    </transition>
  </div>`

  // Create an Icon Vue component so its easier to add within the Vue template
  Vue.component('svg-icon', {
    props: ['iconName'],
    mounted() {
      $(this.$el).load(`/dist/images/careers-quiz/${this.iconName}.svg`)
    },
    template: '<span class="svg-wrap"></span>',
  })

  // The main quiz Vue app
  new Vue({
    el: '.careers-quiz__vue-container',
    template: templateHTML,
    data() {
      return {
        hasStarted: false,
        score: {},
        matchedCareers: [],
        questions: [
          {
            id: 'q1',
            text: 'I prefer...',
            options: [
              { id: Attributes.WORK_WITH_PEOPLE, text: 'Interacting with people', icon: 'icon-conversation' },
              { id: Attributes.TOOLS_MACHINERY, text: 'Working with tools, machinery or software', icon: 'icon-mechanic-tools' },
              { id: Attributes.WORK_WITH_ANIMALS, text: 'Working with animals', icon: 'icon-working-with-animals' },
            ],
          },
          {
            id: 'q2',
            text: 'I get the most satisfaction from...',
            options: [
              { id: Attributes.HELP_PEOPLE, text: 'Helping others', icon: 'icon-people-info' },
              { id: Attributes.TEACHING, text: 'Teaching people new skills', icon: 'icon-abc-book' },
              { id: Attributes.WORK_WITH_HANDS, text: 'Working with my hands', icon: 'icon-hand' },
              { id: Attributes.COMPUTERS, text: "Working on a computer", icon:"icon-desktop-computer"},
            ],
          },
          {
            id: 'q3',
            text: 'I prefer to work...',
            options: [
              { id: Attributes.WORK_INSIDE, text: 'Inside', icon: 'icon-house' },
              { id: Attributes.WORK_OUTSIDE, text: 'Outside', icon: 'icon-trees' },
            ],
          },
          {
            id: 'q4',
            text: 'I most enjoy...',
            options: [
              { id: Attributes.ONE_ON_ONE, text: 'Providing one on one care', icon: 'icon-people-heart' },
              { id: Attributes.COMMUNITY_PROBS, text: 'Solving community problems', icon: 'icon-person-mind' },
              { id: Attributes.KIDS, text: 'Working with kids', icon: 'icon-parent-child' },
              { id: Attributes.ADULTS, text: 'Working with adults', icon: 'icon-crowd' },
              { id: Attributes.MANUAL_LABOUR, text: 'Doing manual labour', icon: 'icon-electric-drill' },
              { id: Attributes.GADGETS, text: 'Working with technology and gadgets', icon: 'icon-usb-cable' },
              { id: Attributes.CREATIVE, text: "Being creative", icon:"icon-painter"},
              { id: Attributes.NUMBERS, text: 'Working with numbers', icon: 'icon-blackboard-2plus1' },
              { id: Attributes.PLANTS, text: "Working with plants or animals", icon:"icon-pot-plant"},
              // {id: Attributes.PROCESS, text: "Following a defined set of processes", icon:""},
            ],
          },
          {
            id: 'q5',
            text: 'I would like to...',
            options: [
              { id: Attributes.EMPLOYEE, text: 'Work for someone else as an employee', icon: 'icon-employees' },
              { id: Attributes.OWN_BUSINESS, text: 'Run my own business or work as an independent contractor', icon: 'icon-transaction' },
            ],
          },
          {
            id: 'q6',
            text: 'I would like to...',
            options: [
              { id: Attributes.HEALTHCARE, text: 'Work in a healthcare environment', icon: 'icon-health' },
              { id: Attributes.COMMUNITY, text: 'Work in the community', icon: 'icon-community' },
              { id: Attributes.OFFICE, text: 'Work in an office', icon: 'icon-sit-computer' },
              { id: Attributes.SCHOOL, text: 'Work in a school or classroom environment', icon: 'icon-teacher-students' },
              { id: Attributes.LOCAL_TRAVEL, text: 'Travel locally to different work locations', icon: 'icon-local-travel' },
              { id: Attributes.KITCHEN, text: "Work in a kitchen", icon:"icon-baker-hat"},
              // {id: Attributes.SALON, text: "Work in a salon", icon:""},
              { id: Attributes.FARM, text: "Work on a farm or in an animal clinic", icon:"icon-barn"},
              // {id: Attributes.FACTORY, text: "Work in a factory", icon:""},
            ],
          },
          {
            id: 'q7',
            text: 'I would prefer to ...',
            options: [
              { id: Attributes.SHIFT_WORK, text: 'Do shift work', icon: 'icon-truck-clock' },
              { id: Attributes.NINE_TO_FIVE, text: 'Work 9am to 5pm, Monday to Friday', icon: 'icon-calendar' },
              { id: Attributes.OWN_HOURS, text: 'Set my own work hours', icon: 'icon-person-clock' },
            ],
          },
          {
            id: 'q8',
            text: 'I am available to...',
            options: [
              { id: Attributes.TAFE_2YR, text: 'Study at TAFE for up to 2 years', icon: 'icon-calendar-2yr' },
              { id: Attributes.TAFE_1YR, text: 'Study at TAFE for up to 1 year', icon: 'icon-calendar-1yr' },
              // {id: Attributes.TAFE_18MO, text: "Study at TAFE for 18 months"},
              { id: Attributes.TAFE_6MO, text: 'Study at TAFE for up to 6 months', icon: 'icon-calendar-6mo' },
              { id: Attributes.APPRENTICE, text: 'Study at TAFE and complete an apprenticeship or traineeship', icon: 'icon-hard-hat' },
            ],
          },
        ],
        careers: [
          {
            name: 'Nurse',
            slug: 'nurse',
            description: 'As a nurse, you’ll work directly with patients, providing daily medical care and treatment.',
            attributes: [
              Attributes.WORK_WITH_PEOPLE,
              Attributes.HELP_PEOPLE,
              Attributes.WORK_INSIDE,
              Attributes.ONE_ON_ONE,
              Attributes.EMPLOYEE,
              Attributes.HEALTHCARE,
              Attributes.SHIFT_WORK,
              Attributes.TAFE_2YR,
            ],
          },
          {
            name: 'Nursing Assistant',
            slug: 'nursing-assistant',
            description: 'Support patients through their daily routines, helping them complete exercise, mobility, and hygiene activities',
            attributes: [
              Attributes.WORK_WITH_PEOPLE,
              Attributes.HELP_PEOPLE,
              Attributes.WORK_INSIDE,
              Attributes.ONE_ON_ONE,
              Attributes.EMPLOYEE,
              Attributes.HEALTHCARE,
              Attributes.SHIFT_WORK,
              Attributes.TAFE_1YR,
            ],
          },
          {
            name: 'Aged Care Worker',
            slug: 'aged-care-worker',
            description: 'Provide daily care and support to your clients, and help them maintain their health and independence.',
            attributes: [
              Attributes.WORK_WITH_PEOPLE,
              Attributes.HELP_PEOPLE,
              Attributes.WORK_INSIDE,
              Attributes.ONE_ON_ONE,
              Attributes.EMPLOYEE,
              Attributes.HEALTHCARE,
              Attributes.SHIFT_WORK,
              Attributes.TAFE_1YR,
            ],
          },
          {
            name: 'Community Services Worker',
            slug: 'community-services-worker',
            description: 'Work with disadvantaged members of the community and help people improve their lives and reach their personal goals.',
            attributes: [
              Attributes.WORK_WITH_PEOPLE,
              Attributes.HELP_PEOPLE,
              Attributes.WORK_INSIDE,
              Attributes.COMMUNITY_PROBS,
              Attributes.EMPLOYEE,
              Attributes.COMMUNITY,
              Attributes.NINE_TO_FIVE,
              Attributes.TAFE_1YR,
            ],
          },
          {
            name: 'Youth Support Worker',
            slug: 'youth-support-worker',
            description: 'Assist young people as individuals or groups to solve social, emotional and financial problems.',
            attributes: [
              Attributes.WORK_WITH_PEOPLE,
              Attributes.HELP_PEOPLE,
              Attributes.WORK_INSIDE,
              Attributes.COMMUNITY_PROBS,
              Attributes.EMPLOYEE,
              Attributes.COMMUNITY,
              Attributes.NINE_TO_FIVE,
              Attributes.TAFE_1YR,
            ],
          },
          // {
          //   name: 'Drug and Alcohol Support Worker',
          //   slug: 'drug-and-alchohol-support-worker',
          //   description:
          //     'Support people with drug and alcohol addictions, and help them to maintain a sobre lifestyle and achieve their personal goals.',
          //   attributes: [
          //     Attributes.WORK_WITH_PEOPLE,
          //     Attributes.HELP_PEOPLE,
          //     Attributes.WORK_INSIDE,
          //     Attributes.SUPPORT_ADDICTS,
          //     Attributes.EMPLOYEE,
          //     Attributes.COMMUNITY,
          //     Attributes.SHIFT_WORK,
          //     Attributes.TAFE_1YR,
          //   ],
          // },
          {
            name: 'Mental Health Support Worker',
            slug: 'mental-health-support-worker',
            description: 'Support people experiencing mental health issues, and help them achieve their personal goals and live their best lives',
            attributes: [
              Attributes.WORK_WITH_PEOPLE,
              Attributes.HELP_PEOPLE,
              Attributes.WORK_INSIDE,
              Attributes.ONE_ON_ONE,
              Attributes.EMPLOYEE,
              Attributes.COMMUNITY,
              Attributes.SHIFT_WORK,
              Attributes.TAFE_6MO,
            ],
          },
          {
            name: 'Early Childhood Educator',
            slug: 'early-childhood-educator',
            description: 'Work with children and support their learning and development on a day-to-day basis.',
            attributes: [
              Attributes.WORK_WITH_PEOPLE,
              Attributes.TEACHING,
              Attributes.WORK_INSIDE,
              Attributes.KIDS,
              Attributes.EMPLOYEE,
              Attributes.SCHOOL,
              Attributes.SHIFT_WORK,
              Attributes.TAFE_1YR,
            ],
          },
          {
            name: 'Trainer and Assessor',
            description: 'Help people develop the skills they need to succeed in the workplace by delivering specialised training programs.',
            slug: 'trainer-and-assessor',
            attributes: [
              Attributes.WORK_WITH_PEOPLE,
              Attributes.TEACHING,
              Attributes.WORK_INSIDE,
              Attributes.ADULTS,
              Attributes.OWN_BUSINESS,
              Attributes.SCHOOL,
              Attributes.NINE_TO_FIVE,
              Attributes.TAFE_1YR,
            ],
          },
          {
            name: 'Plumber',
            description:
              'Plumbers install and maintain plumbing and sewerage systems, as well as gas, ventilation, heating/cooling, and roof drainage.',
            slug: 'plumber',
            attributes: [
              Attributes.TOOLS_MACHINERY,
              Attributes.WORK_WITH_HANDS,
              Attributes.WORK_INSIDE,
              Attributes.NUMBERS,
              Attributes.OWN_BUSINESS,
              Attributes.LOCAL_TRAVEL,
              Attributes.MANUAL_LABOUR,
              Attributes.APPRENTICE,
            ],
          },
          {
            name: 'Electrician',
            slug: 'electrician',
            description:
              'Electricians are responsible for designing, connecting, and maintaining the electrical infrastructure that powers our society.',
            attributes: [
              Attributes.TOOLS_MACHINERY,
              Attributes.WORK_WITH_HANDS,
              Attributes.WORK_INSIDE,
              Attributes.NUMBERS,
              Attributes.OWN_BUSINESS,
              Attributes.LOCAL_TRAVEL,
              Attributes.GADGETS,
              Attributes.APPRENTICE,
            ],
          },
          {
            name: 'Veterinary Nurse',
            slug: 'vet-nurse',
            description: 'Translate your love for animals into a career as you care for animals under treatment.',
            attributes: [
              Attributes.WORK_WITH_ANIMALS,
              Attributes.HELP_PEOPLE,
              Attributes.WORK_INSIDE,
              Attributes.PLANTS,
              Attributes.EMPLOYEE,
              Attributes.FARM,
              Attributes.SHIFT_WORK,
              Attributes.TAFE_2YR,
            ]
          },
          {
            name: "Bookkeeper",
            slug: "bookkeeper",
            description: "Provide essential services to businesses, including maintaining accurate records of financial transactions and producing financial statements.",
            attributes:[
              Attributes.TOOLS_MACHINERY,
              Attributes.COMPUTERS,
              Attributes.WORK_INSIDE,
              Attributes.NUMBERS,
              Attributes.OWN_BUSINESS,
              Attributes.OFFICE,
              Attributes.NINE_TO_FIVE,
              Attributes.TAFE_6MO
            ]
          },
          {
            name: "Chef",
            slug: "chef",
            description: "Explore your passion for making food and work in commercial kitchens; from fine dining restaurants, to cafés and food trucks.",
            attributes:[
              Attributes.TOOLS_MACHINERY,
              Attributes.WORK_WITH_HANDS,
              Attributes.WORK_INSIDE,
              Attributes.CREATIVE,
              Attributes.EMPLOYEE,
              Attributes.KITCHEN,
              Attributes.SHIFT_WORK,
              Attributes.APPRENTICE
            ]
          },
          // {
          //   name: "Baker",
          //   attributes:[
          //     Attributes.TOOLS_MACHINERY,
          //     Attributes.WORK_WITH_HANDS,
          //     Attributes.WORK_INSIDE,
          //     Attributes.CREATIVE,
          //     Attributes.EMPLOYEE,
          //     Attributes.KITCHEN,
          //     Attributes.SHIFT_WORK,
          //     Attributes.APPRENTICE
          //   ]
          // },
     
          // {
          //   name: "Systems Engineer",
          //   attributes:[
          //     Attributes.TOOLS_MACHINERY,
          //     Attributes.COMPUTER,
          //     Attributes.WORK_INSIDE,
          //     Attributes.NUMBERS,
          //     Attributes.EMPLOYEE,
          //     Attributes.OFFICE,
          //     Attributes.NINE_TO_FIVE,
          //     Attributes.TAFE_6MO
          //   ]
          // },
          // {
          //   name: "Events Manager",
          //   attributes:[
          //     Attributes.WORK_WITH_PEOPLE,
          //     Attributes.COMPUTER,
          //     Attributes.WORK_INSIDE,
          //     Attributes.CREATIVE,
          //     Attributes.OWN_BUSINESS,
          //     Attributes.COMMUNITY,
          //     Attributes.SHIFT_WORK,
          //     Attributes.APPRENTICE,
          //   ]
          // },
          // {
          //   name: "Hairdresser",
          //   attributes:[
          //     Attributes.WORK_WITH_PEOPLE,
          //     Attributes.WORK_WITH_HANDS,
          //     Attributes.WORK_INSIDE,
          //     Attributes.CREATIVE,
          //     Attributes.OWN_BUSINESS,
          //     Attributes.SALON,
          //     Attributes.SHIFT_WORK,
          //     Attributes.APPRENTICE
          //   ]
          // },
          // {
          //   name: "Horticulturist",
          //   attributes:[
          //     Attributes.TOOLS_MACHINERY,
          //     Attributes.WORK_WITH_HANDS,
          //     Attributes.WORK_OUTSIDE,
          //     Attributes.PLANTS,
          //     Attributes.EMPLOYEE,
          //     Attributes.FARM,
          //     Attributes.NINE_TO_FIVE,
          //     Attributes.TAFE_1YR
          //   ]
          // },
          // {
          //   name: "Graphic Designer",
          //   attributes:[
          //     Attributes.TOOLS_MACHINERY,
          //     Attributes.COMPUTER,
          //     Attributes.WORK_INSIDE,
          //     Attributes.CREATIVE,
          //     Attributes.OWN_BUSINESS,
          //     Attributes.OFFICE,
          //     Attributes.NINE_TO_FIVE,
          //     Attributes.TAFE_18MO
          //   ]
          // },
          // {
          //   name: "Food Processor",
          //   attributes:[
          //     Attributes.TOOLS_MACHINERY,
          //     Attributes.WORK_WITH_HANDS,
          //     Attributes.WORK_INSIDE,
          //     Attributes.PROCESS,
          //     Attributes.EMPLOYEE,
          //     Attributes.FACTORY,
          //     Attributes.SHIFT_WORK,
          //     Attributes.APPRENTICE
          //   ]
          // },
        ],
      }
    },
    created() {},
    watch: {},
    methods: {
      onStartClick() {
        focusOnElement('.careers-quiz', 'slow')
        this.hasStarted = true
        this.startQuiz()
      },
      startQuiz() {
        this.score = {}
      },
      restartQuiz() {
        focusOnElement('.careers-quiz', 'slow', () => {
          this.startQuiz()
        })
      },
      selectOption(question, option) {
        // If we are answering this question for the first time, we should scroll to the next question
        const scrollNext = !this.questionIsAnswered(question)

        this.$set(this.score, question.id, option.id)
        this.updateMatchedCareers() // TODO: this should be done in a watch

        if (scrollNext) {
          // Wait a moment for better effect
          setTimeout(() => {
            if (this.quizIsComplete) focusOnElement('.careers-quiz__results', 'slow')
            else focusOnElement('.careers-quiz__screen.current', 'slow')
          }, 400)
        }
      },
      optionIsSelected(question, option) {
        return this.score[question.id] ? this.score[question.id] === option.id : false
      },
      questionIsAnswered(question) {
        return this.score[question.id] != null
      },

      // The most important business logic of the app - based on the questions answered,
      // calculated the best matched careers. The more questions are answered, the more
      // accurate this becomes.

      // This is not an approach of 'only include the matching careers' its more like 'order all
      // the careers based on best to worst matched.

      // This weighting that drives the sort, is based (SORRY I RAN OUT OF TIME WRITING THIS)

      updateMatchedCareers() {
        const userScores = Object.values(this.score)

        this.matchedCareers = this.careers
          .reduce((jobs, c) => {
            const careerScores = c.attributes

            const matched = Object.keys(Attributes).reduce((accum, key) => {
              const attr = Attributes[key]
              if (userScores.indexOf(attr) != -1 && careerScores.indexOf(attr) != -1) accum++
              return accum
            }, 0)

            if (matched > 0) {
              jobs.push({ slug: c.slug, name: c.name, description: c.description, percent: matched / careerScores.length })
            }

            return jobs
          }, [])
          .sort((a, b) => b.percent - a.percent)
      },
    },

    computed: {
      answeredQuestionCount() {
        let count = 0
        for (count = 0; count < this.questions.length; count++) {
          const q = this.questions[count]
          if (this.score[q.id] == null) break
        }
        return count
      },
      quizIsComplete() {
        return this.answeredQuestionCount == this.questions.length
      },
      results() {
        const matched = this.matchedCareers

        if (matched.length === 0) return []

        let jobs = [matched[0]]

        if (matched.length > 1) {
          for (let i = 1; i < this.matchedCareers.length; i++) {
            let job = this.matchedCareers[i]
            if (jobs[0].percent != job.percent) break
            jobs.push(job)
          }
        }

        return jobs
      },
      displayedQuestions() {
        return this.questions.slice(0, this.answeredQuestionCount + 2)
      },
    },
  })
})()
